// extracted by mini-css-extract-plugin
module.exports = {"bottom":"bottom__165Pn","left":"left__2TqOQ","right":"right__2E29W","disabled":"disabled__2b1zG"};